module.exports = __webpack_public_path__ + "static/media/login-background.55fc3a1f.jpg";